import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { PaymentSuccessPage } from '@/billing/pages/payment-successful';

export const Route = createFileRoute('/billing/payment-successful')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: PaymentSuccessfulRoute
});

function PaymentSuccessfulRoute() {
  return <PaymentSuccessPage/>;
}
